/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography, RACButton, RACCheckBox, RACModalCard } from "@rentacenter/racstrap";
import doflogo from "../../../images/logo.svg";
import { useHistory, useParams } from "react-router-dom";

import { dofStyles } from "../JSStyles/dofStyles";
import DOFHeader from "./Header";
import { useTranslation } from "react-i18next";
import { IdentityContext } from "../context/userInformation/IdentityContextProvider";
import { ReactComponent as Alerticon } from '../images/no-records-found.svg';


const WelcomePage: React.FC = () => {
  const { t } = useTranslation();
  const classes: any = dofStyles();

  const history = useHistory();
  const context = useContext(IdentityContext);
  const [policyEnabled, SetPolicyEnabled] = useState(false)
  const dofAuthSessionValue: any = window.sessionStorage.getItem("dofAuthValues");
  const sessionStorageValues: any = JSON.parse(dofAuthSessionValue);

  if (!context) {
    return <div> {t("Application is not available")}</div>;
  }

  const { linkExpirationPopup, setLinkExpirationPopup, IDValidationEnable, setIDValidationEnable, featureFlagDetails, setLiveLinessCheckEnable } = context;




  const handleStartBtn = async () => {
    debugger
    if (sessionStorageValues?.idDocType == 'MANSELF') {
      history.push(`/selfieupload`);
      return
    }
    else if (featureFlagDetails?.EnableLivelinessCheck == '1' && sessionStorageValues?.idDocType == 'SELF' && sessionStorageValues?.otpVerifyReq != 'Y' ) {
      setLiveLinessCheckEnable(true)
    }
    else if (featureFlagDetails?.EnableIdValidation == '1' && featureFlagDetails?.EnableManualIDUpload == '0' && sessionStorageValues?.otpVerifyReq != 'Y' ) {
      setIDValidationEnable(true)
    }
    history.push(`/identity`);
  };

  useEffect(() => {
    setLinkExpirationPopup(linkExpirationPopup)
  }, [linkExpirationPopup])


  // Function For Link Expiration

  const linkExpirationPopupFn = () => {
    return (
      <Grid item md={12} className="px-2">
        <Grid item md={12} className="text-center" style={{ textAlign: 'center' }}>
          <Grid>
            <Alerticon></Alerticon>
          </Grid>
          <Typography style={{ marginTop: '25px', marginBottom: '10px', fontSize: '18px' }}>
            Link has expired. Please try again using a new link
          </Typography>
        </Grid>
      </Grid>
    );
  };

  return (
    <>

      <DOFHeader
        identity={true}
        residence={true}
        income={false}
        reference={false}
        activeStep="Income"
      />
      {!linkExpirationPopup ? (<Grid className={classes.referenceContainer}>
        <Typography className={classes.title}>{t("Welcome to RAC")}</Typography>
        {(sessionStorageValues?.idDocType == 'SELF' || sessionStorageValues?.idDocType == 'MANSELF') && featureFlagDetails?.EnableLivelinessCheck == '1' ? <Typography className={classes.subtitle}>{t("Let’s verify your liveliness check")}</Typography>
          : <Typography className={classes.subtitle}>{t("LET'S start creating your profile")}</Typography>
        }
        {sessionStorageValues?.idDocType != 'SELF' && sessionStorageValues?.idDocType != 'MANSELF' ?

          <>  <p className={classes.text}>{t("First we need some basic information that will include:")}</p>
            <ul className={classes.list} style={{ color: '#0F99D6' }}>
              <li style={{ marginTop: '5px' }}><Typography style={{ color: 'black' }}>{t("Identity Validation")} </Typography></li>
              <li style={{ marginTop: '5px' }}><Typography style={{ color: 'black' }}>{t("Privacy Notice")} </Typography></li>
              <li style={{ marginTop: '5px' }}><Typography style={{ color: 'black' }}>{t("Residence")} </Typography></li>
              <li style={{ marginTop: '5px' }}><Typography style={{ color: 'black' }}>{t("Income")} </Typography></li>
            </ul></> : null}


        <Typography style={{ textAlign: 'left' }}>
          {t("Note: ")}<br />
          {t("This procedure will take about 3 minutes to finish.")}<br />
          {sessionStorageValues?.idDocType != 'SELF' && sessionStorageValues?.idDocType != 'MANSELF' ? t("Ensure you have a mobile device to receive the OTP.") : null}

        </Typography>
        <Typography>
        </Typography>
        <Grid style={{ display: 'flex', alignItems: 'center' }}>
          <RACCheckBox
            title=""
            checked={policyEnabled}
            onClick={() => { SetPolicyEnabled(!policyEnabled) }}
          />
          <Typography>{t("I hereby state that I have read, understand, and agree with the")} <a href="https://www.rac.mx/aviso-de-privacidad-integral/" style={{ color: '#2179FE' }} target="_blank" rel="noopener noreferrer">{t("Privacy Notice")}</a></Typography>
        </Grid>
        <div >

          <RACButton className={classes.startButton} onClick={() => handleStartBtn()} disabled={!policyEnabled}
            variant='contained'
            color='primary'
          >{t("Let's Start")}</RACButton>
        </div >
      </Grid>) : null}


      <RACModalCard
        isOpen={linkExpirationPopup}
        maxWidth={'sm'}
        borderRadius={'25px !important'}
        closeIcon={false}
        onClose={() => {
          setLinkExpirationPopup(false)
        }}

        //eslint-disable-next-line react/no-children-prop
        children={linkExpirationPopupFn()}
      ></RACModalCard>
    </>
  );
};

export default WelcomePage;
